// Sezione collassabile del form di progettazione con campi dinamici
import { Collapsible, CollapsibleContent, CollapsibleTrigger } from '../ui/collapsible';
import {
  Settings,
  Building,
  Sun,
  Zap,
  Battery,
  CheckCircle2,
  FileText,
  ChevronDown,
  ChevronRight,
} from 'lucide-react';
import { FormField } from './FormField';

const SECTION_ICONS = {
  dati_input: Building,
  configurazione_impianto: Settings,
  moduli_fotovoltaici: Sun,
  inverter: Zap,
  sistema_accumulo: Battery,
  strutture_accessori: Settings,
  verifiche_tecniche: CheckCircle2,
  note_finali: FileText,
};

export function FormSection({ section, isExpanded, onToggle, formData, onFieldChange, readOnly }) {
  const SectionIcon = SECTION_ICONS[section.id] || Settings;

  return (
    <Collapsible
      open={isExpanded}
      onOpenChange={onToggle}
      className="border rounded-lg bg-card"
    >
      <CollapsibleTrigger className="w-full p-4 flex items-center justify-between hover:bg-accent/50 rounded-t-lg">
        <div className="flex items-center gap-3">
          <SectionIcon className="h-5 w-5 text-primary" />
          <div className="text-left">
            <h3 className="font-semibold">{section.title}</h3>
            {section.description && (
              <p className="text-sm text-muted-foreground">{section.description}</p>
            )}
          </div>
        </div>
        {isExpanded ? <ChevronDown className="h-5 w-5" /> : <ChevronRight className="h-5 w-5" />}
      </CollapsibleTrigger>
      <CollapsibleContent>
        <div className="p-4 pt-0 border-t">
          <div className="grid grid-cols-12 gap-4">
            {[...(section.fields || [])].sort((a, b) => (a.order || 0) - (b.order || 0)).map(field => (
              <FormField
                key={field.name}
                field={field}
                formData={formData}
                onChange={onFieldChange}
                readOnly={readOnly}
              />
            ))}
          </div>
        </div>
      </CollapsibleContent>
    </Collapsible>
  );
}
